import { CircularProgress, Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { Params, useParams } from "react-router-dom";
import { useGetScenesQuery } from "../../services/scene.service";
import { useAppSelector } from "../../store/hooks";
import { useGetMarksQuery } from "../../services/marks.service";
import { PieChart } from "@mui/x-charts";
import { VTTypography, VTUserSelectTable } from "@virtus-tech-repository/virtus-tech-repository";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import VTTimelineItem from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTimelineItem";
import { getImageForSceneOrDefaultImageIfPreviewImageDoesntExist } from "../../utils/getImageForSceneOrDefaultImageIfPreviewImageDoesntExist";
import { useGetScenarioOverviewQuery } from "../../services/scenario.service";
import { useGetScenarioAttemptsQuery } from "../../services/tracking.service";
import {
    UserAttemptRowObjectType,
    VTBasicUserMarksTable,
} from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { setSelectedUser } from "../../store/slices/current.slice";
import MarksViewItem from "./MarksViewItem";
import ScoresContainer from "./ScoresContainer";
import MarksViewItemTable from "./MarksViewItemTable";

interface IProps {
    drawWidth: number;
}

export default function ViewMarksContainerTable({ drawWidth }: IProps) {
    const theme = useTheme();
    const { scenarioId }: Readonly<Params<string>> = useParams();

    const { data: scenes } = useGetScenesQuery(scenarioId ? scenarioId : "");
    const { currentSidePanel, selectedAttempt, selectedUser, currentSidePannelDesiredWidth } = useAppSelector(
        (state) => state.currentReducer,
    );
    const { data: tracking } = useGetScenarioAttemptsQuery({ scenarioId: scenarioId });
    const [correctSceneList, setCorrectSceneList] = useState<{ id: string; user: string; mark: string }[]>([]);

    useEffect(() => {
        console.log("correctSceneList", correctSceneList);
    }, [correctSceneList]);
    return (
        <>
            {tracking ? (
                <div style={{ width: "100%" }}>
                    {tracking.map((mapElement) => (
                        <MarksViewItemTable
                            trackingItem={mapElement}
                            small={selectedUser}
                            setCorrectSceneList={setCorrectSceneList}
                            correctSceneList={correctSceneList}
                        />
                    ))}

                    {correctSceneList.length > 0 && (
                        <VTBasicUserMarksTable sx={{ backgroundColor: "#313131" }} tableData={correctSceneList} />
                    )}
                </div>
            ) : (
                <CircularProgress size={100} />
            )}
        </>
    );
}
